import { z } from 'zod';
import { SourceOfFundsConfigurationZod } from './sourceOfFundsSchemas';
import { ComplianceApiErrorResponseZod } from 'src/api_openapi/v2/compliance/schemas';

const checkResponse = <A>(code: number, decoder: z.ZodType<A>, data: unknown): A => {
    const decodeResult = decoder.safeParse(data);
    if (decodeResult.success) {
        return decodeResult.data;
    }
    console.error('error details', {
        errors: decodeResult.error.errors,
        data,
    });
    throw Error(`Response decoding error /compliance/v1/source-of-funds/config -> delete -> ${code}`);
};

export const Response200ZOD = SourceOfFundsConfigurationZod;
export type Response200Type = z.TypeOf<typeof Response200ZOD>;

export const Response404ZOD = z.unknown();
export type Response404Type = z.TypeOf<typeof Response404ZOD>;

export const Response500ZOD = ComplianceApiErrorResponseZod;
export type Response500Type = z.TypeOf<typeof Response500ZOD>;

const ExtraHeadersZod = z.object({
    authorization: z.string(),
});
type ExtraHeadersType = z.TypeOf<typeof ExtraHeadersZod>;

export type ApiDeleteSourceOfFundsConfigResponseType =
    | {
          status: 200;
          body: Response200Type;
      }
    | {
          status: 404;
          body: Response404Type;
      }
    | {
          status: 500;
          body: Response500Type;
      };

const convertHeaders = (params: Record<string, string | null | undefined>): Record<string, string> => {
    const result: Record<string, string> = {};

    for (const [name, value] of Object.entries(params)) {
        if (value !== null && value !== undefined) {
            result[name] = value;
        }
    }

    return result;
};

export const apiDeleteSourceOfFundsConfigRequest = async (
    api_url: string,
    extraHeaders: ExtraHeadersType
): Promise<ApiDeleteSourceOfFundsConfigResponseType> => {
    const url = `${api_url}/compliance/v1/source-of-funds/config`;
    const headers = convertHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        ...extraHeaders,
    });

    const response = await fetch(url, {
        method: 'DELETE',
        headers,
        credentials: 'include',
    });

    const status = response.status;

    let json: unknown = null;

    try {
        const text = await response.text();
        if (text !== '') {
            try {
                json = JSON.parse(text);
            } catch {
                json = text;
            }
        }
    } catch (_err) {
        throw Error(`Http status ${status} - response body could not be read`);
    }

    if (status === 200) {
        return { status: 200, body: checkResponse(200, Response200ZOD, json) };
    }

    if (status === 404) {
        return { status: 404, body: checkResponse(404, Response404ZOD, json) };
    }

    if (status === 500) {
        return { status: 500, body: checkResponse(500, Response500ZOD, json) };
    }

    throw new Error(`apiDeleteSourceOfFundsConfigRequest - unhandled response ${status}`);
};
